import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=157c8038"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157c8038')) {
      api.createRecord('157c8038', component.options)
    } else {
      api.reload('157c8038', component.options)
    }
    module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=157c8038", function () {
      api.rerender('157c8038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseCheckbox.vue"
export default component.exports